import type { NextRouter } from "next/router";

enum appRoutes {
  ERROR = "/_error",
  HOME_PAGE = "/",
  MY_GEAR = "/my/gear",
  MY_ORDERS = "/my/orders",
  MY_REWARDS = "/my/rewards",
  MY_ACCOUNT = "/my/account",
  LOGIN_PAGE = "/auth/login",
  SIGN_UP_PAGE = "/auth/signup",
  ORDER_VIEW_PAGE = "/order/view",
  RESET_PASSWORD = "/auth/reset-password",
  FORGOT_PASSWORD = "/auth/forgot-password",
  AUTH_DISCORD = "/auth-discord",
  TRANSFER_ORDER = "/order/transfer",
  ORDER_CANCEL_INIT = "/order/cancel",
  ORDER_CANCEL_ABORT = "/order/cancel/abort",
  ORDER_CANCEL_CONFIRM = "/order/cancel/confirm",
  CREATE_ACCOUNT = "/auth/create-account",
  QUEUE = "/queue",
  RETURNS = "/returns",
}

export const publicRoutes: string[] = [
  appRoutes.ERROR,
  appRoutes.LOGIN_PAGE,
  appRoutes.SIGN_UP_PAGE,
  appRoutes.RESET_PASSWORD,
  appRoutes.FORGOT_PASSWORD,
  appRoutes.TRANSFER_ORDER,
  appRoutes.CREATE_ACCOUNT,
  appRoutes.ORDER_CANCEL_INIT,
  appRoutes.ORDER_CANCEL_ABORT,
  appRoutes.ORDER_CANCEL_CONFIRM,
  appRoutes.QUEUE,
];

const authRoutes: string[] = [
  appRoutes.LOGIN_PAGE,
  appRoutes.SIGN_UP_PAGE,
  appRoutes.RESET_PASSWORD,
  appRoutes.FORGOT_PASSWORD,
  appRoutes.CREATE_ACCOUNT,
];

const sideNavRoutes: string[] = [
  appRoutes.HOME_PAGE,
  appRoutes.MY_ACCOUNT,
  appRoutes.MY_ORDERS,
  appRoutes.MY_REWARDS,
  appRoutes.ORDER_VIEW_PAGE,
];

export function isPublicRoute(router: NextRouter) {
  return publicRoutes.includes(router.pathname);
}

export function isSideNavRoute(router: NextRouter) {
  return sideNavRoutes.includes(router.pathname);
}

export default appRoutes;
